import { combineReducers } from "redux";

import { loadingReducer } from "./loadingReducer";
import { shadeReducer } from "./shadeReducer";
import { hashReducer, originReducer, variantReducer, sessionIDReducer, productIDReducer, referrerReducer } from "./queryReducer";
import { engineReducer } from "./engineReducer";
import { settingsReducer } from "./settingsReducer";
import { codeReducer, promptReducer , webViewReducer} from "./codeReducer";
import { heightReducer, widthReducer } from "./viewReducer";

export const rootReducer = combineReducers({
  loading: loadingReducer,
  settings: settingsReducer,
  variant: variantReducer,
  hash: hashReducer,
  origin: originReducer,
  shadeState: shadeReducer,
  engine: engineReducer,
  viewWidth: widthReducer,
  viewHeight: heightReducer,
  viewQR: codeReducer,
  viewPrompt: promptReducer,
  webViewPrompt : webViewReducer,
  session_id: sessionIDReducer,
  product_id: productIDReducer,
  referrer: referrerReducer,
})
